import {Component, h} from 'preact'
import InputGroup from '../ui-components/InputGroup'


interface Props {
  controlUrl: string,
  title: string,
  onChange: (state: {title: string}) => void
}

interface State {
  title: string
}

export class CommunityCategoryWithHelp extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      title: props.title
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle }, () => this.props.onChange({ title: this.state.title }))
  }

  render ({ controlUrl } : Props, { title }: State) {
    return (
      <div>
        <InputGroup
          title='Title'
          type='text'
          onChange={(e: ChangeEvent) => { this.onChangeTitle(e.target.value) }}
          value={title} />
        <div className='widget-configuration_info-box'>
          <strong>✨ How to edit community category card </strong>
          <p> Please go to <a target='_blank' href={`${controlUrl}/settings/category/overview`}>community category overview in control</a> to reorder the categories. And in each parent category page, you can change title, description and visual (thumbnail image) for every card.</p>
        </div>
      </div>
    )
  }
}

export default CommunityCategoryWithHelp

